export const STATUS = Object.freeze({
	ERROR: 'ERROR',
	IDLE: 'IDLE',
	LOADING: 'LOADING',
	SUCCESS: 'SUCCESS',
});

export const ACCESS_TO_SENSITIVE_INFO_RESTRICTED = 'access_to_sensitive_info_restricted';

export const ACCESS_RESTRICTED_BLOCKED_DEALER = 'access_restricted_blocked_dealer';
